import Super from 'client-portal/controllers/-request/information';
import classic from 'ember-classic-decorator';

@classic
export default class SiteRequestInformationIndex extends Super {}
